import { render, staticRenderFns } from "./reward-item.vue?vue&type=template&id=001c9259"
import script from "./reward-item.vue?vue&type=script&lang=js"
export * from "./reward-item.vue?vue&type=script&lang=js"
import style0 from "./reward-item.vue?vue&type=style&index=0&id=001c9259&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports